import { initFields } from './components/fields';
import { initPasswordField } from './components/legacy/PasswordMaskedField';
import { initAccordions } from './components/accordions';
import { initToggleSlideElements, initElementEnhance } from './utils';
import { initPopups } from './components/legacy/tooltips';
import { initCustomPulldown } from './components/legacy/customPulldown/customPulldown';
import { initCustomRadio } from './components/legacy/customRadio';
import initLegacyFieldValidation from './utils/legacy/fieldValidations';

export default ($context, { legacyEnabled = true } = {}) => {
  initFields('xvx-field__control', 'xvx-field', $context);
  initFields('xvx-custom-field__control', 'xvx-custom-field', $context);

  initAccordions('xvx-accordion', $context);

  initToggleSlideElements({ $context });
  initElementEnhance($context);

  if (legacyEnabled) {
    initPopups().init($context);
    initCustomPulldown().initializeWidget();
    initCustomRadio().initializeWidget();
    initPasswordField($context);
    initLegacyFieldValidation($context);
  }
};
